import type { JSX } from 'react';
import { styled, css } from 'styled-components';
import { isUndefined } from '@wistia/type-guards';
import { useSegmentedControlValue } from './useSegmentedControlValue';
import { useSelectedItemStyle } from './useSelectedItemStyle';

export const selectedItemIndicatorStyles = css`
  background-color: var(--wui-color-bg-fill-white);
  border-radius: var(--wui-border-radius-rounded);
  box-shadow: var(--wui-elevation-01);
`;

export const SelectedItemIndicatorDiv = styled.div`
  ${selectedItemIndicatorStyles}
  left: 0;
  position: absolute;
  top: 50%;
  transition:
    transform var(--wui-motion-duration-02) var(--wui-motion-ease-out),
    width var(--wui-motion-duration-02) var(--wui-motion-ease-out);
  z-index: var(--wui-zindex-under);
`;

export const SelectedItemIndicator = (): JSX.Element | null => {
  const selectedValue = useSegmentedControlValue();
  const { selectedItemIndicatorStyle } = useSelectedItemStyle();

  if (!selectedValue || isUndefined(selectedItemIndicatorStyle)) {
    return null;
  }

  return (
    <SelectedItemIndicatorDiv
      data-wui-selected-item-indicator={true}
      style={selectedItemIndicatorStyle}
    />
  );
};
